import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserStateService } from '@frontend/sports/user/feature';
import { Store } from '@ngrx/store';
import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';
import { Observable, map } from 'rxjs';

import BetslipActions from '../../../base/store/actions';
import { betslipSelector } from '../../../base/store/selectors';
import { IBetslipRootState, IBetslipState } from '../../../base/store/state';
import { BetslipState } from '../../../core/betslip-state';
import { BetslipResultConfigurationBase, EditBetResultConfiguration } from '../../result/services/result-configuration.service';
import { EditBetActions } from '../actions';
import { EditBetTrackingLocation } from '../edit-bet.tracking.model';

@Component({
    selector: 'bs-betslip-edit-mybet-container',
    templateUrl: './edit-bet-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: BetslipResultConfigurationBase, useClass: EditBetResultConfiguration }],
    styleUrls: ['./edit-bet-container.scss'],
    standalone: false,
})
export class EditMybetContainerComponent {
    state$: Observable<IBetslipState>;
    @Input() inColumn = false;
    trackingInformation = EditBetTrackingLocation;
    module = EpcotModule.MyBetsBetSlip;
    oddsDisplayFormat$: Observable<OddsDisplayFormat>;

    constructor(
        private store: Store<IBetslipRootState>,
        userState: UserStateService,
        public sitecore: Sitecore,
    ) {
        this.state$ = store.select(betslipSelector);

        this.oddsDisplayFormat$ = userState.userState$().pipe(map((state) => state.oddsFormat || OddsDisplayFormat.EU));
    }

    get BetslipStates(): { Result: BetslipState } {
        return {
            Result: BetslipState.Result,
        };
    }

    closeResultClick(): void {
        this.store.dispatch(EditBetActions.exitEditBet());
        this.store.dispatch(BetslipActions.setState({ state: BetslipState.Edit }));
    }
}
